

























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Button, Card, Tooltip } from 'element-ui';
import { PartnerFields } from '@/types/graphql/schemaTypes';
import { partnerService } from '@/services/PartnerService.ts';

@Component({
  components: {
    'el-button': Button,
    'el-card': Card,
    'el-tooltip': Tooltip
  }
})
export default class PartnerList extends Vue {
  @Prop({ default: false, type: Boolean }) isLoading!: boolean;
  @Prop({ required: true, type: Array }) partners!: PartnerFields[];

  private loading = false;

  private alertError() {
    this.$store.dispatch('Alert/addAlert', {
      type: 'error',
      message: this.$t('error.push'),
      time: 2000
    });
  }

  private async deletePartner(partnerId) {
    if (!this.loading) {
      try {
        this.loading = true;

        const response = await partnerService.deletePartner(partnerId);

        if (response) {
          this.$emit('refresh');
          this.$store.dispatch('Alert/addAlert', {
            type: 'success',
            message: this.$t('success.deleted'),
            time: 2000
          });
        }
      } catch (error) {
        this.alertError();
      } finally {
        this.loading = false;
      }
    }
  }
}
